import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Button, Modal } from "react-bootstrap";
import swal from "sweetalert";
import { post, postFormData } from "../../../helpers/api_helper";
import {
  POST_GetTestingRawDataSheetList,
  POST_TestingRawDataSheetFileSave,
} from "../../../helpers/url_helper";
import { errorMessage, successMessage } from "../CommonFunctions";

const getTestingStatusColor = (testingStatus) =>
  testingStatus == 1
    ? "#ed7c79"
    : testingStatus == 2
      ? "#80c9ff"
      : testingStatus == 3
        ? "#4aa493"
        : testingStatus == 4
          ? "#419841"
          : testingStatus == 5
            ? "#f79f50"
            : "";

// Test wise Raw Data Sheet upload popup for one TC (InwardMaterial).
// Loads its own test list, so it can be used from any page that has InwardMaterialIDEncrypted.
const RawDataSheetUploadModal = ({
  show,
  onHide,
  InwardMaterialIDEncrypted,
  TCNo,
  fnCallback,
}) => {
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [isLoading, setIsLoading] = useState(false);
  const [testList, setTestList] = useState([]);
  const [files, setFiles] = useState({});

  useEffect(() => {
    if (show && InwardMaterialIDEncrypted) {
      setFiles({});
      getTestList();
    } else {
      setTestList([]);
      setFiles({});
    }
  }, [show, InwardMaterialIDEncrypted]);

  const getTestList = () => {
    setIsLoading(true);
    post(POST_GetTestingRawDataSheetList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InwardMaterialIDEncrypted: InwardMaterialIDEncrypted,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTestList(response?.List ?? []);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const saveFile = (testDetailID, isDeleted) => {
    const formData = new FormData();
    formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypt", AuthUser?.BranchIDEncrypt);
    formData.append("InwardMaterialIDEncrypt", InwardMaterialIDEncrypted);
    formData.append("InwardMaterialTestDetailIDEncrypt", testDetailID);
    formData.append(
      "ModifiedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );
    formData.append("IsDeleted", isDeleted);
    if (!isDeleted) {
      formData.append("RawDataSheetFile", files[testDetailID]);
    }

    setIsLoading(true);
    postFormData(POST_TestingRawDataSheetFileSave, formData)
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setFiles((prev) => ({ ...prev, [testDetailID]: null }));
          getTestList();
          if (fnCallback) fnCallback();
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const deleteFile = (testDetailID) => {
    swal({
      title: "Are you sure you want to delete the raw data sheet?",
      text: "You won't be able to revert this!",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          text: "No",
          value: false,
          visible: true,
          className: "btn-sm",
        },
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "btn-sm",
        },
      },
    }).then((confirmed) => {
      if (confirmed) {
        saveFile(testDetailID, true);
      }
    });
  };

  return (
    <Modal
      className="fade"
      show={show}
      onHide={onHide}
      size="lg"
      backdrop="static"
    >
      <Spin
        size="large"
        spinning={isLoading}
        tip={"Loading..."}
        style={{ position: "fixed" }}
      >
        <Modal.Header>
          <Modal.Title>Raw Data Sheet - {TCNo}</Modal.Title>
          <Button
            type="button"
            variant=""
            className="btn-close"
            onClick={onHide}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive active-projects style-1 shorting mb-2">
            <table className="table dataTable no-footer mb-0">
              <thead>
                <tr>
                  <th width="30%">Test</th>
                  <th width="15%">Current File</th>
                  <th width="35%">Upload File</th>
                  <th width="20%" style={{ textAlign: "left" }}>
                    Upload
                  </th>
                </tr>
              </thead>
              <tbody>
                {testList?.length > 0 ? (
                  testList.map((itemtest, indxtest) => (
                    <tr key={indxtest}>
                      <td style={{ whiteSpace: "normal" }}>
                        <span
                          className="btn-sm"
                          style={{
                            backgroundColor: getTestingStatusColor(
                              itemtest?.TestingStatus,
                            ),
                            color: "#fff",
                          }}
                        >
                          {itemtest.TestName}
                        </span>
                      </td>
                      <td>
                        {itemtest?.RawDataSheetFilePath ? (
                          <a
                            href={itemtest.RawDataSheetFilePath}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-eye me-1"></i>View
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        <input
                          key={
                            itemtest.InwardMaterialTestDetailIDEncrypted +
                            (itemtest?.RawDataSheetFilePath ?? "")
                          }
                          type="file"
                          className="form-control form-control-sm"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            setFiles((prev) => ({
                              ...prev,
                              [itemtest.InwardMaterialTestDetailIDEncrypted]:
                                file,
                            }));
                          }}
                        />
                      </td>
                      <td style={{ textAlign: "left" }}>
                        <Button
                          variant="primary btn-sm me-1"
                          title={
                            itemtest?.RawDataSheetFilePath
                              ? "Replace"
                              : "Upload"
                          }
                          disabled={
                            !files[itemtest.InwardMaterialTestDetailIDEncrypted]
                          }
                          onClick={() =>
                            saveFile(
                              itemtest.InwardMaterialTestDetailIDEncrypted,
                              false,
                            )
                          }
                        >
                          <i className="fa fa-upload"></i>
                        </Button>
                        {itemtest?.RawDataSheetFilePath && (
                          <Button
                            variant="danger btn-sm"
                            title="Delete"
                            onClick={() =>
                              deleteFile(
                                itemtest.InwardMaterialTestDetailIDEncrypted,
                              )
                            }
                          >
                            <i className="fa fa-trash"></i>
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} style={{ textAlign: "left" }}>
                      <div>{"No Record Found..."}</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="danger btn-sm" onClick={onHide}>
            <i className="fa fa-cancel"></i> Close
          </Button> */}
        </Modal.Footer>
      </Spin>
    </Modal>
  );
};

export default RawDataSheetUploadModal;
